import {
  ACTIVATING_GOOGLE_TAG_MANAGER_REQUEST, ACTIVATING_GOOGLE_TAG_MANAGER_SUCCEDDED, ACTIVATING_GOOGLE_TAG_MANAGER_FAILED,
  UPDATING_GOOGLE_TAG_MANAGER_REQUEST, UPDATING_GOOGLE_TAG_MANAGER_SUCCEDDED, UPDATING_GOOGLE_TAG_MANAGER_FAILED,
} from '../../actions/actionTypes.jsx';

import { combineReducers } from 'redux';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  activation: {
    activating: false,
    error: null
  },
  deactivation: {
    deactivating: false,
    error: null
  }
};

function googleTagManagerReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIVATING_GOOGLE_TAG_MANAGER_REQUEST:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: true,
          error: null
        }
      })
    case ACTIVATING_GOOGLE_TAG_MANAGER_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: false,
          error: null
        }
      })
    case ACTIVATING_GOOGLE_TAG_MANAGER_FAILED:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: false,
          error: action.payload
        }
      })

    case UPDATING_GOOGLE_TAG_MANAGER_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_GOOGLE_TAG_MANAGER_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_GOOGLE_TAG_MANAGER_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })   
    default:
      return state
  }
}

export { googleTagManagerReducer };